import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Homepage from "./pages/Homepage";
import About from "./pages/About";
import Businesses from "./pages/Businesses";
import Contact from "./pages/Contact";
import OEMServices from "./pages/OEMServices";
import TherapeuticDiets from "./pages/TherapeuticDiets";
import Research from "./pages/Research";
import Compliance from "./pages/Compliance";
import CorporateStructure from "./pages/CorporateStructure";
import Certifications from "./pages/Certifications";
import PSCatering from "./pages/PSCatering";
import FCFoodIndustries from "./pages/FCFoodIndustries";
import FirstCuisine from "./pages/FirstCuisine";
import AdminApp from "./pages/AdminApp";

// Scroll to top component that watches route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin routes (no header/footer) */}
          <Route path="/admin" element={<AdminApp />} />
          <Route path="/admin/*" element={<AdminApp />} />
          
          {/* Public routes (with header/footer) */}
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Homepage />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/about/story" element={<About />} />
                  <Route path="/about/structure" element={<CorporateStructure />} />
                  <Route path="/about/certifications" element={<Certifications />} />
                  <Route path="/businesses" element={<Businesses />} />
                  <Route path="/businesses/first-cuisine" element={<FirstCuisine />} />
                  <Route path="/businesses/ps-catering" element={<PSCatering />} />
                  <Route path="/businesses/fc-industries" element={<FCFoodIndustries />} />
                  <Route path="/expertise" element={<TherapeuticDiets />} />
                  <Route path="/expertise/therapeutic-diets" element={<TherapeuticDiets />} />
                  <Route path="/expertise/research-development" element={<Research />} />
                  <Route path="/expertise/compliance" element={<Compliance />} />
                  <Route path="/oem-services" element={<OEMServices />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;